import { GET_STORE_CATALOGUE_FAILURE, GET_STORE_CATALOGUE_REQUEST, GET_STORE_CATALOGUE_SUCCESS } from "redux/actions/action-type";

const initalState = {
    getStoreCatalogueResponse: [],
    isGetStoreCatalogueError: false,
    isGetStoreCatalogueSuccess: false,
    isGetStoreCatalogueLoading: false,
};

const createManualOrderStoresReducer = (state = initalState, { type, getStoreCatalogueResponse }) => {
    switch (type) {
        case GET_STORE_CATALOGUE_REQUEST:
            return {
                ...state,
                isGetStoreCatalogueLoading: true,
                isGetStoreCatalogueError: false,
                isGetStoreCatalogueSuccess: false
            };
        case GET_STORE_CATALOGUE_SUCCESS:
            return {
                ...state,
                getStoreCatalogueResponse: getStoreCatalogueResponse,
                isGetStoreCatalogueLoading: false,
                isGetStoreCatalogueError: false,
                isGetStoreCatalogueSuccess: true,
            };
        case GET_STORE_CATALOGUE_FAILURE:
            return {
                ...state,
                getStoreCatalogueResponse: getStoreCatalogueResponse,
                isGetStoreCatalogueLoading: false,
                isGetStoreCatalogueError: true,
                isGetStoreCatalogueSuccess: false
            };       
        default:
            return state;
    }
};

export default createManualOrderStoresReducer;